/* [2026-11-03 · Claude · np-cart] rüte — вибір Нової Пошти в кошику + передзаповнення чекауту.
   Як працює:
   1) у кошику рядок «Куди доставити?» → шторка: Відділення/Поштомат, місто, відділення (API НП напряму, без ключа);
   2) вибір зберігається в атрибути кошика (_np_*) → видно в замовленні;
   3) кнопка «Оформити замовлення» веде на /checkout?checkout[shipping_address][...] —
      місто, відділення й індекс уже вписані, кошик НЕ перезбирається (подарунки/бандли/промокоди цілі).
   Якщо доставку не обрано — кнопка спершу відкриває шторку (можна пропустити).
   Стилі: рядок у кошику має інлайн-CSS у snippets/cart-drawer.liquid (щоб не залежав від мережі),
   а CSS шторки цей скрипт вантажить сам перед першим відкриттям.
   Відкат: deploy.py rollback. */
(function () {
  if (window.__ruteNP) return;
  window.__ruteNP = true;

  // ВИМИКАЧ. false = бачать лише ті, хто відкрив сайт з ?np=1 (тест); true = всі покупці. ?np=0 — вимкнути тест.
  var LIVE = true;
  var on = LIVE;
  try {
    var qs = location.search;
    if (/[?&]np=1\b/.test(qs)) localStorage.setItem('rnp_on', '1');
    if (/[?&]np=0\b/.test(qs)) localStorage.removeItem('rnp_on');
    if (localStorage.getItem('rnp_on') === '1') on = true;
  } catch (e) {}
  if (!on) return;
  document.documentElement.classList.add('rnp-on');

  var NP = 'https://api.novaposhta.ua/v2.0/json/';
  var POSTOMAT = 'f9316480-5f2d-425d-bc2c-ac7cd29decf0';
  var QUICK = ['Київ', 'Львів', 'Одеса', 'Харків', 'Дніпро'];
  var cache = {};
  var S = { type: 'branch', city: null, wh: null, pending: false };

  function np(model, method, props) {
    var key = model + method + JSON.stringify(props);
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch(NP, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ apiKey: '', modelName: model, calledMethod: method, methodProperties: props })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (!j.success) throw new Error('np');
      cache[key] = j.data;
      return j.data;
    });
  }
  function searchCities(q) {
    return np('Address', 'searchSettlements', { CityName: q, Limit: '20', Page: '1' }).then(function (d) {
      return ((d[0] && d[0].Addresses) || []).filter(function (a) { return a.Warehouses > 0; }).map(function (a) {
        return { ref: a.Ref, label: a.Present, name: a.MainDescription };
      });
    });
  }
  function searchWh(q) {
    var props = { SettlementRef: S.city.ref, Limit: q ? '100' : '60', Page: '1' };
    if (S.type === 'postomat') props.TypeOfWarehouseRef = POSTOMAT;
    if (/^\d+$/.test(q)) props.WarehouseId = q; else if (q) props.FindByString = q;
    return np('AddressGeneral', 'getWarehouses', props).then(function (d) {
      return d.filter(function (w) {
        return S.type === 'postomat' ? w.CategoryOfWarehouse === 'Postomat' : w.CategoryOfWarehouse !== 'Postomat';
      }).map(function (w) {
        return {
          ref: w.Ref, num: w.Number, label: w.Description,
          short: (S.type === 'postomat' ? 'Поштомат №' : 'Відділення №') + w.Number,
          zip: /^\d{5}$/.test(w.PostalCodeUA || '') ? w.PostalCodeUA : ''
        };
      }).sort(function (a, b) { return (+a.num || 1e9) - (+b.num || 1e9); }).slice(0, 50);
    });
  }

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function getCart() { return fetch('/cart.js', { headers: { accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function filled(a) { return !!(a && a._np_city && a._np_warehouse); }

  function checkoutUrl(a) {
    var zip = /^\d{5}$/.test(a._np_zip || '') ? a._np_zip : '01001';
    var p = [];
    // email з попапа −15% (раніше його підставляв окремий перехоплювач wel15-fix — ми спрацьовуємо раніше, тому несемо email самі)
    try { var em = localStorage.getItem('rute_lead_email'); if (em) p.push(['checkout[email]', em]); } catch (e) {}
    p = p.concat([
      ['checkout[shipping_address][country]', 'UA'],
      ['checkout[shipping_address][city]', a._np_city],
      ['checkout[shipping_address][address1]', a._np_warehouse],
      ['checkout[shipping_address][zip]', zip]
    ]);
    return '/checkout?' + p.map(function (x) { return x[0] + '=' + encodeURIComponent(x[1]); }).join('&');
  }

  function plainCheckout() {
    try { var em = localStorage.getItem('rute_lead_email'); if (em) return '/checkout?checkout[email]=' + encodeURIComponent(em); } catch (e) {}
    return '/checkout';
  }

  /* CSS шторки вантажимо на вимогу: у сторінці його немає, тому ніщо не гальмує завантаження.
     Якщо файл не приїхав — не показуємо напівзламану шторку, а просто ведемо в звичайний чекаут. */
  var cssState = 0; // 0 — не пробували, 1 — вантажиться, 2 — готово, 3 — не вийшло
  var cssP = null;
  function ensureCss() {
    if (cssState === 2) return Promise.resolve();
    if (cssState === 1 && cssP) return cssP;
    cssP = new Promise(function (res, rej) {
      var holder = document.querySelector('[data-rnp-css]');
      var href = holder && holder.getAttribute('data-rnp-css');
      if (!href) { cssState = 3; rej(); return; }
      cssState = 1;
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.setAttribute('data-rnp-sheet', '');
      var done = false;
      var fail = function () {
        if (done) return; done = true;
        cssState = 3; cssP = null;
        if (l.parentNode) l.parentNode.removeChild(l); // прибираємо биті лінк, щоб наступна спроба була чесною
        rej();
      };
      var t = setTimeout(fail, 3000);
      l.onload = function () { if (done) return; done = true; clearTimeout(t); cssState = 2; res(); };
      l.onerror = fail;
      document.head.appendChild(l);
    });
    return cssP;
  }
  // підтягуємо заздалегідь, коли сторінка вже завантажилась — щоб шторка відкривалась миттєво
  function preloadCss() { setTimeout(function () { ensureCss().catch(function () {}); }, 1200); }
  if (document.readyState === 'complete') preloadCss();
  else window.addEventListener('load', preloadCss);

  /* ---------- шторка ---------- */
  var el;
  function build() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'rnp';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'rnp-title');
    el.innerHTML =
      '<div class="rnp__scrim" data-rnp-close></div>' +
      '<div class="rnp__panel">' +
        '<header class="rnp__hd">' +
          '<button type="button" class="rnp__back" data-rnp-close aria-label="Назад"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 18l-6-6 6-6"/></svg></button>' +
          '<h2 id="rnp-title">Куди доставити?</h2>' +
        '</header>' +
        '<div class="rnp__body">' +
          '<p class="rnp__sub">Нова Пошта · 1–2 дні по Україні</p>' +
          '<div class="rnp__seg" role="radiogroup" aria-label="Спосіб доставки">' +
            '<button type="button" role="radio" data-rnp-type="branch">Відділення</button>' +
            '<button type="button" role="radio" data-rnp-type="postomat">Поштомат</button>' +
          '</div>' +
          '<label class="rnp__lbl" for="rnp-city">Місто</label>' +
          '<div class="rnp__quick">' + QUICK.map(function (c) { return '<button type="button" data-rnp-quick="' + c + '">' + c + '</button>'; }).join('') + '</div>' +
          '<div class="rnp__field">' +
            '<input id="rnp-city" type="text" autocomplete="off" autocapitalize="sentences" enterkeyhint="search" placeholder="Почни вводити назву">' +
            '<button type="button" class="rnp__clear" data-rnp-clear="city" aria-label="Очистити" hidden>×</button>' +
            '<div class="rnp__list" data-rnp-list="city" role="listbox" hidden></div>' +
          '</div>' +
          '<label class="rnp__lbl" for="rnp-wh" data-rnp-whlbl>Відділення</label>' +
          '<div class="rnp__field">' +
            '<input id="rnp-wh" type="text" autocomplete="off" enterkeyhint="search" placeholder="Спершу обери місто" disabled>' +
            '<button type="button" class="rnp__clear" data-rnp-clear="wh" aria-label="Очистити" hidden>×</button>' +
            '<div class="rnp__list" data-rnp-list="wh" role="listbox" hidden></div>' +
          '</div>' +
          '<p class="rnp__hint">Ім’я і телефон отримувача вкажеш на наступному кроці — адреса вже буде вписана.</p>' +
        '</div>' +
        '<footer class="rnp__ft">' +
          '<button type="button" class="rnp__done" data-rnp-done disabled>Готово</button>' +
          '<button type="button" class="rnp__skip" data-rnp-skip hidden>Заповню на сторінці оплати</button>' +
        '</footer>' +
      '</div>';
    document.body.appendChild(el);
    bind();
    return el;
  }

  function $(s) { return el.querySelector(s); }
  function paintType() {
    el.querySelectorAll('[data-rnp-type]').forEach(function (b) {
      var on = b.getAttribute('data-rnp-type') === S.type;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $('[data-rnp-whlbl]').textContent = S.type === 'postomat' ? 'Поштомат' : 'Відділення';
    var wh = $('#rnp-wh');
    wh.disabled = !S.city;
    wh.placeholder = !S.city ? 'Спершу обери місто' : 'Номер або вулиця';
  }
  function paintDone() {
    var ok = !!(S.city && S.wh);
    var d = $('[data-rnp-done]');
    d.disabled = !ok;
    d.textContent = S.pending ? 'Перейти до оплати' : 'Готово';
    $('[data-rnp-skip]').hidden = !S.pending;
    $('[data-rnp-clear="city"]').hidden = !$('#rnp-city').value;
    $('[data-rnp-clear="wh"]').hidden = !$('#rnp-wh').value;
  }
  function showList(kind, items, emptyText) {
    var box = $('[data-rnp-list="' + kind + '"]');
    box._items = items;
    box.innerHTML = items.length
      ? items.map(function (x, i) { return '<button type="button" role="option" data-i="' + i + '">' + esc(x.label) + '</button>'; }).join('')
      : '<div class="rnp__note">' + esc(emptyText || 'Нічого не знайдено') + '</div>';
    box.hidden = false;
  }
  function hideLists() { el.querySelectorAll('.rnp__list').forEach(function (b) { b.hidden = true; }); }

  function pickCity(c) {
    S.city = c; S.wh = null;
    $('#rnp-city').value = c.label;
    $('#rnp-wh').value = '';
    hideLists(); paintType(); paintDone();
    loadWh('');
    setTimeout(function () { $('#rnp-wh').focus(); }, 30);
  }
  function pickWh(w) {
    S.wh = w;
    $('#rnp-wh').value = w.label;
    hideLists(); paintDone();
    $('[data-rnp-done]').focus();
  }
  var whSeq = 0;
  function loadWh(q) {
    if (!S.city) return;
    var seq = ++whSeq;
    showList('wh', [], 'Шукаю…');
    searchWh(q).then(function (items) {
      if (seq !== whSeq) return;
      showList('wh', items, S.type === 'postomat' ? 'Поштоматів не знайдено — спробуй «Відділення»' : 'Не знайдено, спробуй номер');
    }).catch(function () { if (seq === whSeq) showList('wh', [], 'Нова Пошта не відповідає, спробуй ще раз'); });
  }

  function bind() {
    var tCity, tWh, citySeq = 0;
    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-rnp-close]')) { close(); return; }
      var ty = t.closest('[data-rnp-type]');
      if (ty) {
        var nt = ty.getAttribute('data-rnp-type');
        if (nt !== S.type) { S.type = nt; S.wh = null; $('#rnp-wh').value = ''; paintType(); paintDone(); if (S.city) loadWh(''); }
        return;
      }
      var qc = t.closest('[data-rnp-quick]');
      if (qc) {
        var name = qc.getAttribute('data-rnp-quick');
        searchCities(name).then(function (items) {
          var exact = items.filter(function (x) { return x.name === name && /^м\./.test(x.label); })[0] || items[0];
          if (exact) pickCity(exact);
        }).catch(function () {});
        return;
      }
      var cl = t.closest('[data-rnp-clear]');
      if (cl) {
        var k = cl.getAttribute('data-rnp-clear');
        if (k === 'city') { S.city = null; S.wh = null; $('#rnp-city').value = ''; $('#rnp-wh').value = ''; hideLists(); paintType(); $('#rnp-city').focus(); }
        else { S.wh = null; $('#rnp-wh').value = ''; $('#rnp-wh').focus(); loadWh(''); }
        paintDone();
        return;
      }
      var opt = t.closest('.rnp__list [data-i]');
      if (opt) {
        var box = opt.parentNode, item = box._items[+opt.getAttribute('data-i')];
        if (box.getAttribute('data-rnp-list') === 'city') pickCity(item); else pickWh(item);
        return;
      }
      if (t.closest('[data-rnp-done]')) { save(); return; }
      if (t.closest('[data-rnp-skip]')) {
        try { sessionStorage.setItem('rnp_skip', '1'); } catch (er) {}
        location.href = plainCheckout();
        return;
      }
      if (!t.closest('.rnp__field')) hideLists();
    });
    $('#rnp-city').addEventListener('input', function () {
      S.city = null; S.wh = null; $('#rnp-wh').value = ''; paintType(); paintDone();
      var q = this.value.trim();
      clearTimeout(tCity);
      if (q.length < 2) { $('[data-rnp-list="city"]').hidden = true; return; }
      tCity = setTimeout(function () {
        var seq = ++citySeq;
        showList('city', [], 'Шукаю…');
        searchCities(q).then(function (items) { if (seq === citySeq) showList('city', items.slice(0, 12)); })
          .catch(function () { if (seq === citySeq) showList('city', [], 'Нова Пошта не відповідає, спробуй ще раз'); });
      }, 250);
    });
    $('#rnp-wh').addEventListener('input', function () {
      S.wh = null; paintDone();
      var q = this.value.trim();
      clearTimeout(tWh);
      tWh = setTimeout(function () { loadWh(q); }, 250);
    });
    $('#rnp-wh').addEventListener('focus', function () { if (S.city && !S.wh) loadWh(this.value.trim()); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
        var box = e.target.parentNode.querySelector('.rnp__list');
        var first = box && !box.hidden && box.querySelector('[data-i]');
        if (first) { e.preventDefault(); first.click(); }
      }
    });
  }

  function open(pending) {
    ensureCss().then(function () { openNow(pending); }, function () {
      cssP = null;
      if (pending) location.href = plainCheckout();
    });
  }

  function openNow(pending) {
    build();
    // монтуємо всередину #CartDrawer, якщо кошик відкритий (інакше focus-trap Sense краде фокус з полів);
    // кошик перерендерює #CartDrawer.innerHTML — тому перемонтовуємо при кожному відкритті
    var host = document.getElementById('CartDrawer');
    var target = host && host.closest('cart-drawer.active') ? host : document.body;
    if (el.parentNode !== target) target.appendChild(el);
    S.pending = !!pending;
    getCart().then(function (c) {
      var a = c.attributes || {};
      if (filled(a)) {
        S.type = a._np_type === 'postomat' ? 'postomat' : 'branch';
        S.city = { ref: a._np_city_ref, label: a._np_city };
        S.wh = { ref: a._np_warehouse_ref, label: a._np_warehouse, short: a._np_warehouse_short, zip: a._np_zip };
        $('#rnp-city').value = a._np_city;
        $('#rnp-wh').value = a._np_warehouse;
      }
      paintType(); paintDone();
    }).catch(function () { paintType(); paintDone(); });
    paintType(); paintDone();
    el.hidden = false;
    document.documentElement.classList.add('rnp-open');
    document.querySelectorAll('.rute-btn-loading[name="checkout"]').forEach(function (b) { b.classList.remove('rute-btn-loading'); });
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    setTimeout(function () { if (!S.city) $('#rnp-city').focus({ preventScroll: true }); }, 250);
    track('rnp_open');
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-in');
    document.documentElement.classList.remove('rnp-open');
    hideLists();
    setTimeout(function () { el.hidden = true; }, 220);
    S.pending = false;
    var btn = document.querySelector('.rute-btn-loading[name="checkout"]');
    if (btn) btn.classList.remove('rute-btn-loading');
  }

  function save() {
    if (!(S.city && S.wh)) return;
    var attrs = {
      _np_type: S.type,
      _np_city: S.city.label,
      _np_city_ref: S.city.ref || '',
      _np_warehouse: S.wh.label,
      _np_warehouse_short: S.wh.short || '',
      _np_warehouse_ref: S.wh.ref || '',
      _np_zip: S.wh.zip || ''
    };
    var btn = $('[data-rnp-done]');
    btn.disabled = true;
    btn.classList.add('is-busy');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {}).then(function () {
      paintRows(attrs);
      track('add_shipping_info', { shipping_tier: 'Nova Poshta ' + S.type });
      if (S.pending) { location.href = checkoutUrl(attrs); return; }
      btn.classList.remove('is-busy');
      close();
    });
  }

  /* рядок у кошику (liquid малює його з атрибутів; тут — оновлення без перерендеру) */
  function paintRows(a) {
    document.querySelectorAll('[data-rnp-row]').forEach(function (r) {
      r.classList.add('is-filled');
      var city = String(a._np_city || '').split(',')[0].replace(/^(м\.|смт|с\.)\s*/, '');
      r.querySelector('.rute-np-row__t').textContent = 'Нова Пошта · ' + (a._np_warehouse_short || '');
      r.querySelector('.rute-np-row__s').textContent = city;
      r.querySelector('.rute-np-row__a').textContent = 'Змінити';
    });
  }

  function track(name, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: name };
      if (extra) for (var k in extra) o[k] = extra[k];
      window.dataLayer.push(o);
    } catch (e) {}
  }

  /* ---------- відкриття з кошика ---------- */
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-rnp-row]');
    if (r) { e.preventDefault(); open(false); }
  });

  /* ---------- перехоплення «Оформити замовлення» ---------- */
  window.addEventListener('click', function (e) {
    var b = e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (!b || b.disabled || b.closest('.rnp')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    b.classList.add('rute-btn-loading');
    var done = false;
    var fallback = setTimeout(function () { if (!done) location.href = plainCheckout(); }, 6000);
    getCart().then(function (c) {
      done = true; clearTimeout(fallback);
      var a = c.attributes || {};
      if (filled(a)) { location.href = checkoutUrl(a); return; }
      var skipped = false;
      try { skipped = sessionStorage.getItem('rnp_skip') === '1'; } catch (er) {}
      if (skipped) { location.href = plainCheckout(); return; }
      open(true); // спінер знімаємо вже у openNow, коли шторка показалась
    }).catch(function () { done = true; clearTimeout(fallback); location.href = plainCheckout(); });
  }, true); // window + capture: спрацьовує раніше за document-перехоплювач wel15-fix

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.rute-btn-loading[name="checkout"]').forEach(function (b) { b.classList.remove('rute-btn-loading'); });
  });

  window.RuteNP = { open: open };
})();
